export const REGISTER_SUCCESS = 'Register/REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'Register/REGISTER_FAILURE';
export const RESET_REGISTER_PARAMS = 'Register/RESET_REGISTER_PARAMS';
export const LOAD_PROVINCES = 'Register/LOAD_PROVINCES';
export const LOAD_CITIES = 'Register/export cosnt LOAD_CITIES';